export default "__VITE_ASSET__DnWORsb3__"